import AddIcon from "@mui/icons-material/Add";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useLoaderData, useNavigate } from "react-router-dom";
import { PagedResponse } from "../../types/Result";
import { ExamTypeCategory } from "../examTypeCategory/type";
import { examTypeCategoryColumns } from "./columns";

export default function ExamTypeCategoryDataGrid() {
  const data = useLoaderData() as PagedResponse<ExamTypeCategory>;
  const navigate = useNavigate();
  return (
    <>
      <DataGrid
        autoHeight
        sx={{ width: "100%" }}
        rows={data.data!}
        getRowId={(row) => row.examTypeCode + row.categoryCode}
        columns={examTypeCategoryColumns}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        initialState={{
          pagination: { paginationModel: { pageSize: 20 } },
        }}
        pageSizeOptions={[10, 20, 50]}
        disableColumnResize
        density="compact"
        slotProps={{
          filterPanel: {
            filterFormProps: {
              logicOperatorInputProps: {
                variant: "outlined",
                size: "small",
              },
              columnInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              operatorInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              valueInputProps: {
                InputComponentProps: {
                  variant: "outlined",
                  size: "small",
                },
              },
            },
          },
        }}
      />
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{ position: "absolute", bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          icon={<AddIcon />}
          tooltipTitle={"Yeni"}
          onClick={() => navigate("new")}
        />
      </SpeedDial>
    </>
  );
}
